import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'

import * as audioActions from '../../Core/Game/AudioContainer/audio.actions'

import * as tutorialSelectors from '../tutorial.selectors'
import * as tutorialActions from '../tutorial.actions'

import StartBattle from '../../Mars/Battles/StartBattle/StartBattle'

const mapDispatchToProps = (dispatch) => {
  return {
    getBattleQuestion: bindActionCreators(tutorialActions.noop, dispatch),
    giveUp: bindActionCreators(tutorialActions.giveUpBattle, dispatch),
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
    addScreen: bindActionCreators(tutorialActions.addScreen, dispatch),
    removeScreen: bindActionCreators(tutorialActions.removeScreen, dispatch),
    removePopup: bindActionCreators(tutorialActions.removePopup, dispatch),
  }
}
const mapStateToProps = (state) => {
  return {
    battle: tutorialSelectors.getCurrentBattle(state),
    individualBattle: tutorialSelectors.getIndividualBattle(state),
    currentUser: tutorialSelectors.getCurrentUser(state),
    rivalInfo: tutorialSelectors.getRivalInfo(state),
    hideTabs: tutorialSelectors.getPhase1HideUI(state),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(StartBattle))
